// extracted by mini-css-extract-plugin
module.exports = {"container":"PatientDetails_container__3x27A","title":"PatientDetails_title__3-bEL","cell":"PatientDetails_cell__353TI"};